import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "M10 20C4.486 20 0 15.514 0 10S4.486 0 10 0s10 4.486 10 10-4.486 10-10 10zm5-11.586A1 1 0 0 0 13.586 7L9 11.586 6.914 9.5A1 1 0 0 0 5.5 10.914l2.793 2.793a1 1 0 0 0 1.414 0L15 8.414z"
});

var SvgCircleTickMajorFilled = function SvgCircleTickMajorFilled(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgCircleTickMajorFilled as S };
